<nav class="fga-nav-bar" role="tablist" aria-label="Main navigation">
  @for (item of items; track item.id; let i = $index) {
    <button
      type="button"
      class="fga-nav-bar__tab"
      [class.fga-nav-bar__tab--active]="item.id === activeView"
      role="tab"
      [attr.aria-selected]="item.id === activeView"
      [attr.aria-label]="item.label"
      [attr.tabindex]="item.id === activeView ? 0 : -1"
      (click)="onSelect(item)"
      (keydown)="onKeydown($event, i)"
    >
      <span class="fga-nav-bar__icon" [ngClass]="item.iconClass" aria-hidden="true"></span>
      <span class="fga-nav-bar__label">{{ item.label }}</span>
    </button>
  }
</nav>
